// TODO add translations for this when translations are implemented in search
// For now, only English is supported
const POPULAR_SEARCH_SUGGESTIONS = [
  'Timeline',
  'Gantt Charts',
  'Marketing Reports',
  'Resumes',
  'Infographics',
  'Mind Maps',
  'Presentations',
];

export { POPULAR_SEARCH_SUGGESTIONS };
